var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lm-size-preview-row"},_vm._l((_vm.cols),function(col){return _c('SizeColPreview',{key:col.id,attrs:{"col":col,"size":_vm.size,"rowWidth":_vm.rowWidth}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }